@if (!hideReaderMalfunctionError() && (readerMalfunction$ | async)) {
    <priva-notification status="Danger">{{ readerMalfunctionMessage }}</priva-notification>
} @else if (showButton()) {
    <app-scan-button
        iconState="left"
        iconClass="fas fa-nfc-symbol"
        data-test="scan-nfc-btn"
        text="{{ 'GENERAL.ACTION.SCAN_NFC' | translate }}"
        [isClickable]="false"
    />
}
